import React from 'react'

import { NavLink } from 'react-router-dom'

import { SiteContext } from 'context/site-context'

import { getQS } from 'helpers'

import './index.scss'

const Categories = props => {
  const [ site ] = React.useContext(SiteContext)

  return <React.Fragment>
    {site.categories ? <div className={`categories-container ${props.className || ''}`}>
      <div className="container">
        {props.headline && <h2 dangerouslySetInnerHTML={{ __html: props.headline }} />}
        {!props.headline && <h2>Discover <span className="highlight">so much more</span></h2>}
        <div className="categories-wrapper">
          <ul>
            {site.categories.sort().map( category => <li key={category}><a href={`/results?term=${category}&where=${site.location}${getQS().trim().length > 0 ? `${getQS()}` : ''}`}>{category}</a></li>)}
          </ul>
        </div>
      </div>
    </div> : null}
  </React.Fragment>
}

export default Categories
